module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/bread-036e7673afb40136c89d6c06702c97a7.svg";